import { render } from "./EDADashboard.vue?vue&type=template&id=7b232169"
import script from "./EDADashboard.vue?vue&type=script&lang=js"
export * from "./EDADashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__